<template>

  <div>
    <input type="input" name="MerchantKey" id="input_MerchantKey" v-bind:value="MerchantKey">

    <form method="post" id="ePayment" name="ePayment" v-bind:action="IPAY_URL">
      <input type="input" name="MerchantCode" id="input_MerchantCode" v-bind:value="MerchantCode">
      <input type="input" name="PaymentId" id="input_PaymentId" value="">
      <input type="input" name="RefNo" id="input_RefNo" v-bind:value="RefNo">
      <input type="input" name="Amount" id="input_Amount" v-bind:value="Amount">
      <input type="input" name="Currency" id="input_Currency" v-bind:value="Currency">
      <input type="input" name="ProdDesc" id="input_ProdDesc" v-bind:value="ProdDesc">
      <input type="input" name="UserName" id="input_UserName" v-bind:value="UserName">
      <input type="input" name="UserEmail" id="input_UserEmail" v-bind:value="UserEmail">
      <input type="input" name="UserContact" id="input_UserContact" v-bind:value="UserContact">
      <input type="input" name="Remark" id="input_Remark" v-bind:value="Remark">
      <input type="input" name="Lang" id="input_Lang" value="UTF-8">
      <input type="input" name="SignatureType" id="input_SignatureType" v-bind:value="SignatureType">
      <input type="input" name="Signature" id="input_Signature" v-bind:value="Signature">
      <input type="input" name="ResponseURL" id="input_ResponseURL" v-bind:value="ResponseURL"> 
      <input type="input" name="BackendURL" id="input_BackendURL" v-bind:value="BackendURL"> 
      <input type="input" name="Optional" id="input_Optional" v-bind:value="Optional"> 

      <div class="m-t-sm">
        <div class="btn-group">
          <a href="#" class="btn btn-primary btn-sm" v-on:click.prevent="paymentSubmitClick"><i class="fa fa-shopping-cart"></i> Pay </a>
          <a href="#" class="btn btn-white btn-sm" v-on:click.prevent="paymentCancelClick"> Cancel</a>
        </div>
      </div>

    </form>
  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

export default {
  name: "AppIpay88",
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      IPAY_URL: helper.IPAY_URL,
      MerchantCode: helper.IPAY_MERCHANT_CODE,
      MerchantKey: helper.IPAY_MERCHANT_KEY,
      SignatureType: 'SHA256',

      ResponseURL: 'https://pbills.parkaidemobile.com/payment/ipayResponse',
      BackendURL: 'https://sys.parkaidemobile.com/api2/fund',

      RefNo: null,
      Amount: '',
      ProdDesc: null,
      Currency: 'MYR',
      UserName: null,
      UserEmail: null,
      UserContact: null,
      Remark: null,
      Signature: null,
      Optional: '{"carddetails":"Y", "MDRValues":"Y"}',
    }
  },
  mounted() {
    if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      this.ResponseURL = 'https://parkbills.parkaidemobile.com/payment/ipayResponse';
      this.BackendURL = 'https://sys2.parkaidemobile.com/api2/fund';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      this.ResponseURL = 'https://devpbills.parkaidemobile.com/payment/ipayResponse';
      this.BackendURL = 'https://sys2.parkaidemobile.com/api2/fund';
    }
  },
  methods: {
    paymentSubmitClick() {
      // this.MerchantKey = 'apple'
      // this.MerchantCode = 'M00003'
      // this.RefNo = 'A00000001'
      // this.Amount = '1.00'
      // this.Currency = 'MYR'

      var text = this.MerchantKey + this.MerchantCode + this.RefNo + String(this.Amount).replace('.', '') + this.Currency;
      // text = 'appleM00003A00000001100MYR';
      // var hash = CryptoJS.SHA256(text);
      // var Signature = hash.toString(CryptoJS.enc.Base64);
      // this.Signature = helper.iPaySHA256(text);
      this.SignatureType = 'HMACSHA512'
      this.Signature = helper.iPayHMACSHA256(text, this.MerchantKey);

      this.$nextTick(() => {
        $('#ePayment').submit();
      });
    },
    paymentCancelClick() {
      window.paymentCallback(false);
      window.close();
    },
    paymentPaidClick() {
      window.paymentCallback(true);
      window.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/App/AppIpay88.vue